import type { FaireProductEntity } from "../../entity_types/product";

export const p_ryxz4eu7um: FaireProductEntity = {
  token: "p_ryxz4eu7um",
  type: "product",
  name: "Strawberry Kiwi Non-Alcoholic Kombucha",
  brandToken: "b_s2jesyk5p9",
  brandName: "Walker Brothers",
  imageUrl: "https://cdn.faire.com/fastly/d7bf13cab723c09623bb248d81d5ea620c93c1eb9735cd32cd8757974e9d362a.png",
  galleryImageUrls: [],
  priceDollars: 2.5,
  description: "Bright, refreshing, and irresistibly juicy, organic strawberry purée combines with the tropical tang of organic kiwi purée to deliver the perfect summer beverage.\n\nPlease note: This item is unpasteurized and must be kept refrigerated.\n\nIngredients: Raw Kombucha (Filtered Water, Kombucha Culture, Black Tea*, Green Tea*, Jasmine Tea*, Cane Sugar*), Strawberry Purée*, Kiwi Purée*\n*certified organic ingredients\n\nWalker Brothers Ginger craft kombucha is non-alcoholic, unpasteurized and rich in live probiotics, gluten-free, kosher pareve, and vegan.\n\nPackaged in an aluminum can for ease of recycling\n\nA healthy, non-alcoholic option for fall gatherings, tailgates, Halloween, Thanksgiving, Friendsgiving and holiday parties! A great mixer for drinks as well as a good snack pairing with chips and popcorn. ",
  tags: [],
  msrpDollars: 5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-09T08:04:42.901Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
